/**
 * author: Ananthapadmanabhan V K
 */
import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import "./Profile.scss";
// import profile from './images/Login_img1.png';
import {
  Button,
  Table,
  Form,
  Badge,
  Pagination,
  ProgressBar,
  Tabs,
  Tab,
  Breadcrumb
} from "react-bootstrap";

import {
  BiHome,
  BiPhone,
  BiMailSend,
  BiChevronRight,
  BiDotsHorizontalRounded,
  BiShareAlt,
  BiMenuAltRight,
  BiSearch,
  BiChevronDown,
} from "react-icons/bi";
import { BsFillSquareFill } from "react-icons/bs";
import { CgSortAz } from "react-icons/cg";
import { useNavigate, useParams } from "react-router-dom";
import { withTranslation } from "react-i18next";
import ProfileService from "../../../core/service/ProfileService";
import { ScaleLoader } from "react-spinners";
import ErrorHandlingService from "../../../core/service/ErrorHandlingService";
import { RegulationContext, CompanyContext } from "../../../App";
import Utils from "../../../core/utilities/Utils";
import RiskClassificationBox from "../RiskClassificationBox/RiskClassificationBox";
import AlertBox from "../AlertBox/AlertBox";
import SupplierBasicInfoBox from "../SupplierBasicInfoBox/SupplierBasicInfoBox";
import ProfileCompletenessBox from "../ProfileCompletenessBox/ProfileCompletenessBox";
import SupplierInfoTab from "../SupplierInfoTab/SupplierInfoTab";

const Profile = ({ t }) => {
  const navigate = useNavigate();
  let [loading, setLoading] = useState(false);
  let [color, setColor] = useState("#383cc1");
  const { profile_id } = useParams();
  const [profiledata, setProfileData] = useState({});
  const [profileStatus, setProfileStatus] = useState({});
  const [loadingprofiledata, setLoadingProfileData] = useState(true);
  const [annualyear, setAnnualYear] = useState(new Date().getFullYear());
  const { glbRegulation, setGlbRegulation } = useContext(RegulationContext);
  const glbRegulationId = glbRegulation?.id ? glbRegulation.id : "";
  const { glbCompany, setGlbCompany } = useContext(CompanyContext);
  var lsDat = JSON.parse(localStorage.getItem("authority"));

  var encodedParam = "";
  const companyId = lsDat.profile.company.id;
  if (glbRegulationId && profile_id && companyId) {
    const paramObj = Utils.generateUrlParamCompanyRegulationWithSupplier(
      companyId,
      glbRegulationId,
      profile_id
    );
    encodedParam = Utils.encodeBase64(paramObj);
  }


  useEffect(() => {
    getProfileData();
    getProfileStatus();
  }, [glbRegulationId, glbCompany]);
  const getProfileData = async (e) => {
    encodedParam &&
      ProfileService.getProfileData(encodedParam)
        .then((response) => {
          setProfileData(response.data);
          setLoadingProfileData(false);
        })
        .catch((error) => {
          //ErrorHandlingService.handleError(error.response.status);
          //  console.log("err", error);
        });
  };
  const getProfileStatus = async (e) => {
    encodedParam &&
      ProfileService.getProfileStatus(encodedParam)
        .then((response) => {
          setProfileStatus(response.data);
        })
        .catch((error) => {
          //ErrorHandlingService.handleError(error.response.status);
          //    console.log("err", error);
        });
  };
  return (
    <div className="Profile_Box">
      {loadingprofiledata ? (
        <div className="loader-custom">
          <ScaleLoader color={color} loading={true} size={25} />
        </div>
      ) : (
        <div>
          <div className="List_header">
            <Breadcrumb className="h5">
              <Breadcrumb.Item onClick={() => {
                navigate(`/company_admin/list_supplier`);
              }} > {t("Suppliers.label")}</Breadcrumb.Item>
              <Breadcrumb.Item active> {profiledata?.supplier.legalName}</Breadcrumb.Item>
            </Breadcrumb>
          </div>

          <div className="row px-1">
            <div className="col-lg-3 p-2">
              <div className="card Single_pp_Card">
                <SupplierBasicInfoBox profiledata={profiledata} />
                <ProfileCompletenessBox profileStatus={profileStatus} />
              </div>
            </div>

            <div className="col-lg-9 p-0">
              <div className="row m-0">
                <div className="col-lg-4 p-2">
                  <RiskClassificationBox profileId={profile_id} annualyear={annualyear} />
                </div>

                <div className="col-lg-8 p-2">
                  <AlertBox profileId={profile_id} />
                </div>
              </div>

              <div className="col-lg-12 p-2">
                <div className="Profile_Status_card">
                  <ul>
                    <li>
                      <h6>2</h6>
                      <h6>{t("UnassignedHighPriorityGrievance.label")}</h6>
                    </li>
                    <li>
                      <h6>2</h6>
                      <h6>{t("UnassignedHighPriorityIncidents.label")}</h6>
                    </li>
                    <li>
                      <h6>2</h6>
                      <h6>{t("PendingToSubmitSurveys.label")}</h6>
                    </li>
                    <li>
                      <h6>2</h6>
                      <h6>{t("UnsharedMandatoryDocument.label")}</h6>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <Tabs
            defaultActiveKey="Supplier-info-tab"
            id="fill-tab-example"
            className="All_tab-viewbox 1"
            fill
          >
            <Tab eventKey="Supplier-info-tab" title={t("SupplierInformation.label")}>
              <SupplierInfoTab profiledata={profiledata} />
            </Tab>
            <Tab eventKey="Incidents-tab" title={t("Incidents.label")}>
              <div className="p-2">
                <div className="incident_Card_01 card">
                  <div className="card-body">
                    <div className="incident_card_head01">
                      <h5 className="m-0">{t("Incidents.label")}</h5>
                      <select className="form-select">
                        <option>2022</option>
                        <option>2021</option>
                        <option>2020</option>
                      </select>
                    </div>
                    <div className="row px-1 incident_Card_Status_dt">
                      <div className="col-lg-3 p-2">
                        <h6 className="ICS_head">Status</h6>
                        <ul className="ICS_Status">
                          <li>
                            <h6>Open</h6>
                            <h6>01</h6>
                          </li>
                          <li>
                            <h6>Closed</h6>
                            <h6>05</h6>
                          </li>
                          <li>
                            <h6>In Progress</h6>
                            <h6>01</h6>
                          </li>
                        </ul>
                      </div>

                      <div className="col-lg-3 p-2">
                        <h6 className="ICS_head">Priority</h6>
                        <ul className="ISC_Priority">
                          <li>
                            <h6>05</h6>
                            <h6 className="text-High ms-2">High</h6>
                          </li>
                          <li>
                            <h6>03</h6>
                            <h6 className="text-Medium ms-2">Medium</h6>
                          </li>
                          <li>
                            <h6>01</h6>
                            <h6 className="text-Low ms-2">Low</h6>
                          </li>
                        </ul>
                      </div>

                      <div className="col-lg-3 p-2">
                        <h6 className="ICS_head">Major incident type</h6>
                        <ul className="ISC_M_type">
                          <li>
                            <h6>Hazardous Chemical</h6>
                          </li>
                          <li>
                            <div className="box_g_01 w-50 bg-danger"></div>
                            <h6 className="ms-2">05</h6>
                          </li>
                        </ul>
                        <ul className="ISC_M_type">
                          <li>
                            <h6>Fire breakout</h6>
                          </li>
                          <li>
                            <div className="box_g_01 w-20 bg-warning"></div>
                            <h6 className="ms-2">02</h6>
                          </li>
                        </ul>
                        <ul className="ISC_M_type">
                          <li>
                            <h6>Accidents</h6>
                          </li>
                          <li>
                            <div className="box_g_01 w-10 bg-success"></div>
                            <h6 className="ms-2">01</h6>
                          </li>
                        </ul>
                        <ul className="ISC_M_type">
                          <li>
                            <h6>Pandemic Outbreak</h6>
                          </li>
                          <li>
                            <div className="box_g_01 w-10 bg-success"></div>
                            <h6 className="ms-2">01</h6>
                          </li>
                        </ul>
                        <ul className="ISC_M_type">
                          <li>
                            <h6>Safety Issue</h6>
                          </li>
                          <li>
                            <div className="box_g_01 w-10 bg-success"></div>
                            <h6 className="ms-2">01</h6>
                          </li>
                        </ul>
                      </div>

                      <div className="col-lg-3 p-2">
                        <h6 className="ICS_head">Affected person</h6>
                        <ul className="ISC_M_type">
                          <li>
                            <h6>Employee</h6>
                          </li>
                          <li>
                            <div className="box_g_01 w-50 bg-danger"></div>
                            <h6 className="ms-2">05</h6>
                          </li>
                        </ul>
                        <ul className="ISC_M_type">
                          <li>
                            <h6>Contractor</h6>
                          </li>
                          <li>
                            <div className="box_g_01 w-20 bg-warning"></div>
                            <h6 className="ms-2">03</h6>
                          </li>
                        </ul>
                        <ul className="ISC_M_type">
                          <li>
                            <h6>Supplier</h6>
                          </li>
                          <li>
                            <div className="box_g_01 w-10 bg-warning"></div>
                            <h6 className="ms-2">02</h6>
                          </li>
                        </ul>
                        <ul className="ISC_M_type">
                          <li>
                            <h6>Public</h6>
                          </li>
                          <li>
                            <div className="box_g_01 w-10 bg-success"></div>
                            <h6 className="ms-2">01</h6>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="List_Table_01">
                    <div className="List_table-card01_head px-2 border-bottom">
                      <div className="open_priority_view01">
                        1 incident with high priority is open :{" "}
                        <a href="#">Child labour</a>
                      </div>
                      <div className="List_table-card01_sort">
                        <ul>
                          <li>
                            <a href="#">
                              <BiShareAlt /> {t("Share.label")}
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <BiMenuAltRight /> {t("Sort.label")}
                            </a>
                          </li>
                          <li className="filter">
                            <a href="#">
                              <button className="btn btn-secondary"><CgSortAz /> {t("Filter.label")}</button>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="List_table-card01">
                      <Table responsive="sm">
                        <thead>
                          <tr>
                            <th className="th_check">
                              <Form.Check
                                inline
                                name="group1"
                                type="checkbox"
                                id="inline-checkbox-1"
                              />
                            </th>
                            <th>Incidents type</th>
                            <th>Priority</th>
                            <th>Occurred on</th>
                            <th>Reported on</th>
                            <th>Affected person</th>
                            <th>Status</th>
                            <th>Action taken</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="th_check">
                              {" "}
                              <Form.Check
                                inline
                                name="group1"
                                type="checkbox"
                                id="inline-checkbox-1"
                              />
                            </td>
                            <td>Hazardous chemical</td>
                            <td>
                              <Badge bg="badge-High">High</Badge>
                            </td>
                            <td>June 6, 2022</td>
                            <td>June 6, 2022</td>
                            <td>Contrator</td>
                            <td>
                              <Badge bg="badge-Open">Open</Badge>
                            </td>
                            <td>
                              <select className="form-select w-auto">
                                <option>Take action</option>
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <td className="th_check">
                              {" "}
                              <Form.Check
                                inline
                                name="group1"
                                type="checkbox"
                                id="inline-checkbox-1"
                              />
                            </td>
                            <td>Accidents</td>
                            <td>
                              <Badge bg="badge-Medium">Medium</Badge>
                            </td>
                            <td>May 5, 2022</td>
                            <td>May 6, 2022</td>
                            <td>Employee</td>
                            <td>
                              <Badge bg="badge-Open">Open</Badge>
                            </td>
                            <td>
                              <select className="form-select w-auto">
                                <option>Take action</option>
                              </select>
                            </td>
                          </tr>

                          <tr>
                            <td className="th_check">
                              {" "}
                              <Form.Check
                                inline
                                name="group1"
                                type="checkbox"
                                id="inline-checkbox-1"
                              />
                            </td>
                            <td>Pandemic Outbreak</td>
                            <td>
                              <Badge bg="badge-Medium">Medium</Badge>
                            </td>
                            <td>April 22, 2022</td>
                            <td>May 6, 2022</td>
                            <td>Supplier</td>
                            <td>
                              <Badge bg="badge-Inprogress">In Progress</Badge>
                            </td>
                            <td>Supplier survey</td>
                          </tr>
                          <tr>
                            <td className="th_check">
                              {" "}
                              <Form.Check
                                inline
                                name="group1"
                                type="checkbox"
                                id="inline-checkbox-1"
                              />
                            </td>
                            <td>Fire breakout</td>
                            <td>
                              <Badge bg="badge-High">High</Badge>
                            </td>
                            <td>April 12, 2022</td>
                            <td>May 15, 2022</td>
                            <td>Public</td>
                            <td>
                              <Badge bg="badge-Closed">Closed</Badge>
                            </td>
                            <td>Inspection</td>
                          </tr>
                          <tr>
                            <td className="th_check">
                              {" "}
                              <Form.Check
                                inline
                                name="group1"
                                type="checkbox"
                                id="inline-checkbox-1"
                              />
                            </td>
                            <td>Pandemic Outbreak</td>
                            <td>
                              <Badge bg="badge-Medium">Medium</Badge>
                            </td>
                            <td>April 22, 2022</td>
                            <td>May 6, 2022</td>
                            <td>Supplier</td>
                            <td>
                              <Badge bg="badge-Inprogress">In Progress</Badge>
                            </td>
                            <td>Supplier survey</td>
                          </tr>
                          <tr>
                            <td className="th_check">
                              {" "}
                              <Form.Check
                                inline
                                name="group1"
                                type="checkbox"
                                id="inline-checkbox-1"
                              />
                            </td>
                            <td>Fire breakout</td>
                            <td>
                              <Badge bg="badge-High">High</Badge>
                            </td>
                            <td>April 12, 2022</td>
                            <td>May 15, 2022</td>
                            <td>Public</td>
                            <td>
                              <Badge bg="badge-Closed">Closed</Badge>
                            </td>
                            <td>Inspection</td>
                          </tr>
                          <tr>
                            <td className="th_check">
                              {" "}
                              <Form.Check
                                inline
                                name="group1"
                                type="checkbox"
                                id="inline-checkbox-1"
                              />
                            </td>
                            <td>Pandemic Outbreak</td>
                            <td>
                              <Badge bg="badge-Medium">Medium</Badge>
                            </td>
                            <td>April 22, 2022</td>
                            <td>May 6, 2022</td>
                            <td>Supplier</td>
                            <td>
                              <Badge bg="badge-Inprogress">In Progress</Badge>
                            </td>
                            <td>Supplier survey</td>
                          </tr>
                          <tr>
                            <td className="th_check">
                              {" "}
                              <Form.Check
                                inline
                                name="group1"
                                type="checkbox"
                                id="inline-checkbox-1"
                              />
                            </td>
                            <td>Fire breakout</td>
                            <td>
                              <Badge bg="badge-High">High</Badge>
                            </td>
                            <td>April 12, 2022</td>
                            <td>May 15, 2022</td>
                            <td>Public</td>
                            <td>
                              <Badge bg="badge-Closed">Closed</Badge>
                            </td>
                            <td>Inspection</td>
                          </tr>
                          <tr>
                            <td className="th_check">
                              {" "}
                              <Form.Check
                                inline
                                name="group1"
                                type="checkbox"
                                id="inline-checkbox-1"
                              />
                            </td>
                            <td>Pandemic Outbreak</td>
                            <td>
                              <Badge bg="badge-Medium">Medium</Badge>
                            </td>
                            <td>April 22, 2022</td>
                            <td>May 6, 2022</td>
                            <td>Supplier</td>
                            <td>
                              <Badge bg="badge-Inprogress">In Progress</Badge>
                            </td>
                            <td>Supplier survey</td>
                          </tr>
                          <tr>
                            <td className="th_check">
                              {" "}
                              <Form.Check
                                inline
                                name="group1"
                                type="checkbox"
                                id="inline-checkbox-1"
                              />
                            </td>
                            <td>Fire breakout</td>
                            <td>
                              <Badge bg="badge-High">High</Badge>
                            </td>
                            <td>April 12, 2022</td>
                            <td>May 15, 2022</td>
                            <td>Public</td>
                            <td>
                              <Badge bg="badge-Closed">Closed</Badge>
                            </td>
                            <td>Inspection</td>
                          </tr>
                        </tbody>
                      </Table>
                      <div className="p-2 List_footer_count">
                        <div className="Item_per_pageBox">
                          {/* Items per page */}
                          <select className="form-select">
                            <option>10</option>
                            <option>20</option>
                            <option>30</option>
                          </select>
                        </div>
                        <div className="Count_pages01">1 - 10 of 50</div>
                        <Pagination>
                          <Pagination.First />
                          <Pagination.Prev />
                          <Pagination.Item>{1}</Pagination.Item>
                          <Pagination.Item active>{2}</Pagination.Item>
                          <Pagination.Item>{3}</Pagination.Item>
                          <Pagination.Next />
                          <Pagination.Last />
                        </Pagination>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Tab>
            <Tab eventKey="Surveys-tab" title={t("Surveys.label")}>
              <div className="p-2"></div>
            </Tab>
            <Tab eventKey="Document-tab" title={t("Documents.label")}>
              <div className="p-2">
                <div className="row m-0">
                  <div className="col-lg-12 p-2">
                    <div className="List_Table_01">
                      <div className="List_table-card01_head">
                        <div>
                          <h6 className="m-0">Shared Forms</h6>
                        </div>
                        <div className="List_table-card01_sort">
                          <ul>
                            <li>
                              <a href="#">
                                <BiShareAlt /> {t("Share.label")}
                              </a>
                            </li>
                            <li>
                              <a href="#">
                                <BiMenuAltRight /> {t("Sort.label")}
                              </a>
                            </li>
                            <li className="filter">
                              <a href="#">
                                <button className="btn btn-secondary"><CgSortAz /> {t("Filter.label")}</button>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="card Share_formCard List_table-card01">
                        <Table responsive="sm">
                          <thead>
                            <tr>
                              <th>
                                <Form.Check
                                  inline
                                  name="group1"
                                  type="checkbox"
                                  id="inline-checkbox-1"
                                />
                              </th>
                              <th>Form title</th>
                              <th>Description</th>
                              <th>Created date</th>
                              <th>Submission date</th>
                              <th>Progress</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                {" "}
                                <Form.Check
                                  inline
                                  name="group1"
                                  type="checkbox"
                                  id="inline-checkbox-1"
                                />
                              </td>
                              <td>Company due dilligence</td>
                              <td>Understanding Supplier</td>
                              <td>June 6, 2022</td>
                              <td>June 6, 2022</td>
                              <td>
                                <Badge bg="badge-Completed">Completed</Badge>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {" "}
                                <Form.Check
                                  inline
                                  name="group1"
                                  type="checkbox"
                                  id="inline-checkbox-1"
                                />
                              </td>
                              <td>Employee due dilligence</td>
                              <td>Employee details</td>
                              <td>May 6, 2022</td>
                              <td>May 6, 2022</td>
                              <td>
                                <Badge bg="badge-Viewed">Viewed</Badge>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {" "}
                                <Form.Check
                                  inline
                                  name="group1"
                                  type="checkbox"
                                  id="inline-checkbox-1"
                                />
                              </td>
                              <td>Migrant employee</td>
                              <td>Employee details</td>

                              <td>April 6, 2022</td>
                              <td>April 6, 2022</td>
                              <td>
                                <Badge bg="badge-Submitted">Submitted</Badge>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {" "}
                                <Form.Check
                                  inline
                                  name="group1"
                                  type="checkbox"
                                  id="inline-checkbox-1"
                                />
                              </td>
                              <td>Employee due dilligence</td>
                              <td>Employee details</td>
                              <td>May 6, 2022</td>
                              <td>May 6, 2022</td>
                              <td>
                                <Badge bg="badge-Viewed">Viewed</Badge>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {" "}
                                <Form.Check
                                  inline
                                  name="group1"
                                  type="checkbox"
                                  id="inline-checkbox-1"
                                />
                              </td>
                              <td>Migrant employee</td>
                              <td>Employee details</td>

                              <td>April 6, 2022</td>
                              <td>April 6, 2022</td>
                              <td>
                                <Badge bg="badge-Submitted">Submitted</Badge>
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                        <div className="p-2 List_footer_count">
                          <div className="Item_per_pageBox">
                            {/* Items per page */}
                            <select className="form-select">
                              <option>10</option>
                              <option>20</option>
                              <option>30</option>
                            </select>
                          </div>
                          <div className="Count_pages01">1 - 10 of 50</div>
                          <Pagination>
                            <Pagination.First />
                            <Pagination.Prev />
                            <Pagination.Item>{1}</Pagination.Item>
                            <Pagination.Item active>{2}</Pagination.Item>
                            <Pagination.Item>{3}</Pagination.Item>
                            <Pagination.Next />
                            <Pagination.Last />
                          </Pagination>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 p-2">
                    <div className="List_Table_01">
                      <div className="List_table-card01_head">
                        <div>
                          <h6 className="m-0">Documents</h6>
                        </div>
                        <div className="List_table-card01_sort">
                          <ul>
                            <li>
                              <a href="#">
                                <BiShareAlt /> {t("Share.label")}
                              </a>
                            </li>
                            <li>
                              <a href="#">
                                <BiMenuAltRight /> {t("Sort.label")}
                              </a>
                            </li>
                            <li className="filter">
                              <a href="#">
                                <button className="btn btn-secondary"><CgSortAz /> {t("Filter.label")}</button>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="card dcoument_card01">
                        <div className="p-3 border-bottom">
                          Terms and conditions
                          <p className="m-0">June 6, 2022</p>
                        </div>
                        <div className="p-3 border-bottom">
                          Privacy Policy
                          <p className="m-0">May 6, 2022</p>
                        </div>
                        <div className="p-3">
                          Disclaimer
                          <p className="m-0">April 6, 2022</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Tab>
          </Tabs>
        </div>
      )}
    </div>
  );
};

export default withTranslation()(Profile);
